var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        { staticClass: "selProType" },
        [
          _c("h5", { staticClass: "processTypeLabel" }, [
            _vm._v(_vm._s(_vm.$t("ANALYTICS.SELECT_PROCESS_TYPE")))
          ]),
          _vm._v(" "),
          _c(
            "b-col",
            [
              _c("b-form-select", {
                staticClass: "formselectPT",
                attrs: { options: _vm.processTypes },
                model: {
                  value: _vm.selectedFilterProcessType,
                  callback: function($$v) {
                    _vm.selectedFilterProcessType = $$v
                  },
                  expression: "selectedFilterProcessType"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "4" } },
            [
              _c(
                "b-card",
                [
                  [
                    _c(
                      "b-row",
                      { staticClass: "headers" },
                      [
                        _c("h5", [_vm._v(_vm._s(_vm.$t("CONFIGURED.FIELDS")))]),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { attrs: { cols: "6" } },
                          [
                            _c("b-form-input", {
                              staticClass: "searchBox",
                              attrs: { placeholder: "Search" },
                              on: {
                                input: function($event) {
                                  _vm.searchByText()
                                }
                              },
                              model: {
                                value: _vm.filter,
                                callback: function($$v) {
                                  _vm.filter = $$v
                                },
                                expression: "filter"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          {
                            staticClass: "text-right",
                            staticStyle: { "padding-right": "0px" }
                          },
                          [
                            _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover",
                                    modifiers: { hover: true }
                                  }
                                ],
                                staticClass: "addGroupBtn",
                                attrs: {
                                  size: "sm",
                                  variant: "secondary",
                                  title: _vm.$t("CONFIGURED.ADD_GROUP")
                                },
                                on: {
                                  click: function($event) {
                                    _vm.showAddFieldModal()
                                  }
                                }
                              },
                              [
                                _c("i", { staticClass: "fa fa-plus" }),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("COMMON.ADD")) + " ")
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  _vm._v(" "),
                  _c(
                    "div",
                    { attrs: { id: "groups" } },
                    [
                      !_vm.fieldsLoaded
                        ? _c(
                            "div",
                            [
                              _c(
                                "content-placeholders",
                                [
                                  _c("content-placeholders-img", {
                                    style: { height: "280px" }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedFilterProcessType === null && _vm.fieldsLoaded
                        ? _c(
                            "div",
                            [
                              _c(
                                "b-row",
                                [
                                  _c("b-col", [
                                    _c("br"),
                                    _vm._v(" "),
                                    _c("a", { staticStyle: { color: "red" } }, [
                                      _vm._v("Please Select Process type")
                                    ])
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm.fields.length === 0 && _vm.fieldsLoaded
                          ? _c(
                              "div",
                              [
                                _c(
                                  "b-row",
                                  [
                                    _c("b-col", [
                                      _c("br"),
                                      _vm._v(" "),
                                      _c(
                                        "h4",
                                        { staticStyle: { color: "red" } },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("FORMS.NOTHING"))
                                          )
                                        ]
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.fields, function(processField) {
                        return _vm.fieldsLoaded
                          ? _c(
                              "div",
                              [
                                _vm.currentField.id === processField.id
                                  ? _c(
                                      "b-row",
                                      {
                                        staticClass: "groupName",
                                        on: {
                                          click: function($event) {
                                            _vm.getFieldAlias(processField)
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "a",
                                          { staticClass: "selectedField" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("capitalize")(
                                                  processField.field.replace(
                                                    /_/g,
                                                    " "
                                                  )
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          { staticClass: "text-right" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "actionBtn" },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "b-tooltip",
                                                        rawName:
                                                          "v-b-tooltip.hover",
                                                        modifiers: {
                                                          hover: true
                                                        }
                                                      }
                                                    ],
                                                    staticClass:
                                                      "editBtnSelect",
                                                    attrs: {
                                                      title: _vm.$t(
                                                        "COMMON.EDIT"
                                                      )
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        _vm.openEditField(
                                                          processField
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-pencil",
                                                      attrs: {
                                                        "aria-hidden": "true"
                                                      }
                                                    })
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "b-tooltip",
                                                        rawName:
                                                          "v-b-tooltip.hover",
                                                        modifiers: {
                                                          hover: true
                                                        }
                                                      }
                                                    ],
                                                    attrs: {
                                                      title: _vm.$t(
                                                        "COMMON.DELETE_PERMANENTLY"
                                                      )
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        _vm.confirmDeleteField(
                                                          processField
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-trash",
                                                      staticStyle: {
                                                        color: "red"
                                                      },
                                                      attrs: {
                                                        "aria-hidden": "true"
                                                      }
                                                    })
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _c(
                                      "b-row",
                                      {
                                        on: {
                                          click: function($event) {
                                            _vm.getFieldAlias(processField)
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "a",
                                          { staticClass: "unselectedRows" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("capitalize")(
                                                  processField.field.replace(
                                                    /_/g,
                                                    " "
                                                  )
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          { staticClass: "text-right" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "actionBtn" },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "b-tooltip",
                                                        rawName:
                                                          "v-b-tooltip.hover",
                                                        modifiers: {
                                                          hover: true
                                                        }
                                                      }
                                                    ],
                                                    staticClass:
                                                      "editBtnSelect",
                                                    attrs: {
                                                      title: _vm.$t(
                                                        "COMMON.EDIT"
                                                      )
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        _vm.openEditField(
                                                          processField
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-pencil",
                                                      attrs: {
                                                        "aria-hidden": "true"
                                                      }
                                                    })
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "b-tooltip",
                                                        rawName:
                                                          "v-b-tooltip.hover",
                                                        modifiers: {
                                                          hover: true
                                                        }
                                                      }
                                                    ],
                                                    attrs: {
                                                      title: _vm.$t(
                                                        "COMMON.DELETE_PERMANENTLY"
                                                      )
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        _vm.confirmDeleteField(
                                                          processField
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-trash",
                                                      staticStyle: {
                                                        color: "red"
                                                      },
                                                      attrs: {
                                                        "aria-hidden": "true"
                                                      }
                                                    })
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                              ],
                              1
                            )
                          : _vm._e()
                      })
                    ],
                    2
                  )
                ],
                2
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "8" } },
            [
              _c(
                "b-card",
                [
                  [
                    _c(
                      "b-row",
                      { staticClass: "headers" },
                      [
                        _c("b-col", [
                          _c("h5", [
                            _vm._v(_vm._s(_vm.$t("CONFIGURED.FIELDS_ALIASES")))
                          ])
                        ]),
                        _vm._v(" "),
                        _vm.currentFieldAliases !== null
                          ? _c(
                              "b-col",
                              { staticClass: "text-right" },
                              [
                                _c(
                                  "b-button",
                                  {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.hover",
                                        modifiers: { hover: true }
                                      }
                                    ],
                                    staticClass: "addGroupBtn",
                                    attrs: {
                                      size: "sm",
                                      variant: "secondary",
                                      title: _vm.$t(
                                        "CONFIGURED.ADD_FIELD_ALIAS"
                                      )
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.showAddFieldAliasModal()
                                      }
                                    }
                                  },
                                  [
                                    _c("i", { staticClass: "fa fa-plus" }),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("COMMON.ADD")) + " ")
                                    ])
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "labelBody" },
                    [
                      !_vm.fieldAliasLoaded
                        ? _c(
                            "div",
                            [
                              _c(
                                "content-placeholders",
                                [
                                  _c("content-placeholders-img", {
                                    style: { height: "250px" }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._l(_vm.currentFieldAliases, function(
                            fieldAlias,
                            index
                          ) {
                            return _c("div", [
                              fieldAlias.name !== null
                                ? _c("div", { staticClass: "currFields" }, [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(fieldAlias.name) +
                                        "\n            "
                                    ),
                                    _c("div", { staticClass: "pull-right" }, [
                                      _c(
                                        "a",
                                        {
                                          directives: [
                                            {
                                              name: "b-tooltip",
                                              rawName: "v-b-tooltip.hover",
                                              modifiers: { hover: true }
                                            }
                                          ],
                                          staticClass: "fieldEditBtn",
                                          attrs: {
                                            title: _vm.$t("COMMON.EDIT")
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.showEditFieldAliasModal(
                                                fieldAlias
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-pencil",
                                            attrs: { "aria-hidden": "true" }
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          directives: [
                                            {
                                              name: "b-tooltip",
                                              rawName: "v-b-tooltip.hover",
                                              modifiers: { hover: true }
                                            }
                                          ],
                                          attrs: {
                                            title: _vm.$t(
                                              "COMMON.DELETE_PERMANENTLY"
                                            )
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.showDeleteFieldAliasModal(
                                                fieldAlias
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-trash",
                                            staticStyle: { color: "red" },
                                            attrs: { "aria-hidden": "true" }
                                          })
                                        ]
                                      )
                                    ])
                                  ])
                                : _vm._e()
                            ])
                          })
                    ],
                    2
                  )
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "deleteGrp",
          attrs: {
            centered: "",
            "hide-header-close": "",
            id: "DeleteConfirmationGrp",
            title: _vm.$t("COMMON.DELETE_CONFIRM")
          }
        },
        [
          _c("p", { staticStyle: { color: "red" } }, [
            _vm._v(_vm._s(_vm.$t("COMMON.MSG_PERM_DEL")))
          ]),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "modal-footer" }, slot: "modal-footer" },
            [
              _c(
                "b-btn",
                {
                  attrs: {
                    id: "addNewField",
                    size: "sm",
                    variant: "secondary"
                  },
                  on: {
                    click: function($event) {
                      _vm.deleteField()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("COMMON.DELETE")) + " ")]
              ),
              _vm._v(" "),
              _c(
                "b-btn",
                {
                  attrs: { size: "sm", variant: "light" },
                  on: {
                    click: function($event) {
                      _vm.$refs.deleteGrp.hide()
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("COMMON.CLOSE")) + " ")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "ConfirmModal",
          attrs: {
            centered: "",
            "hide-header-close": "",
            id: "DeleteConfirmationField",
            title: _vm.$t("COMMON.DELETE_CONFIRM")
          }
        },
        [
          _c("p", { staticStyle: { color: "red" } }, [
            _vm._v(_vm._s(_vm.$t("COMMON.MSG_PERM_DEL")))
          ]),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "modal-footer" }, slot: "modal-footer" },
            [
              _c(
                "b-btn",
                {
                  attrs: {
                    id: "addNewField",
                    size: "sm",
                    variant: "secondary"
                  },
                  on: {
                    click: function($event) {
                      _vm.deleteFieldAlias()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("COMMON.DELETE")) + " ")]
              ),
              _vm._v(" "),
              _c(
                "b-btn",
                {
                  attrs: { size: "sm", variant: "light" },
                  on: {
                    click: function($event) {
                      _vm.$refs.ConfirmModal.hide()
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("COMMON.CLOSE")) + " ")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "FieldAliasModal",
          attrs: {
            centered: "",
            "hide-header-close": "",
            id: "FieldAliasModal",
            title: _vm.$t("CONFIGURED.ADD_ALIAS")
          }
        },
        [
          _c(
            "b-form-group",
            [
              _c(
                "b-row",
                [
                  _c("b-col", { attrs: { sm: "2" } }, [
                    _c("label", [_vm._v(_vm._s(_vm.$t("COMMON.NAME")))]),
                    _vm._v(" "),
                    _c("span", { staticClass: "required" }, [_vm._v("*")])
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { sm: "8" } },
                    [
                      _c("b-form-input", {
                        attrs: { placeholder: "Enter" },
                        on: { input: _vm.checkDuplicateAlias },
                        model: {
                          value: _vm.newFieldAliasName,
                          callback: function($$v) {
                            _vm.newFieldAliasName = $$v
                          },
                          expression: "newFieldAliasName"
                        }
                      }),
                      _vm._v(" "),
                      _vm.errorFieldDup
                        ? _c("a", { staticStyle: { color: "red" } }, [
                            _vm._v(
                              _vm._s(_vm.$t("CONFIGURED.FIELD_EXISTS")) + " "
                            )
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "modal-footer" }, slot: "modal-footer" },
            [
              _c(
                "b-btn",
                {
                  attrs: {
                    id: "addNewField",
                    size: "sm",
                    variant: "secondary",
                    disabled: _vm.errorFieldDup || _vm.newFieldAliasName === ""
                  },
                  on: {
                    click: function($event) {
                      _vm.addFieldAlias()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("COMMON.SAVE")) + " ")]
              ),
              _vm._v(" "),
              _c(
                "b-btn",
                {
                  attrs: { size: "sm", variant: "light" },
                  on: {
                    click: function($event) {
                      _vm.$refs.FieldAliasModal.hide()
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("COMMON.CLOSE")) + " ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "editFieldAliasModal",
          attrs: {
            centered: "",
            "hide-header-close": "",
            id: "editFieldAliasModal",
            title: _vm.$t("CONFIGURED.EDIT_ALIAS")
          }
        },
        [
          _c(
            "b-form-group",
            [
              _c(
                "b-row",
                [
                  _c("b-col", { attrs: { sm: "2" } }, [
                    _c("label", [_vm._v(_vm._s(_vm.$t("COMMON.NAME")))]),
                    _vm._v(" "),
                    _c("span", { staticClass: "required" }, [_vm._v("*")])
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { sm: "8" } },
                    [
                      _c("b-form-input", {
                        attrs: { placeholder: "Enter" },
                        on: { input: _vm.checkDuplicateAlias },
                        model: {
                          value: _vm.newFieldAliasName,
                          callback: function($$v) {
                            _vm.newFieldAliasName = $$v
                          },
                          expression: "newFieldAliasName"
                        }
                      }),
                      _vm._v(" "),
                      _vm.errorFieldDup
                        ? _c("a", { staticStyle: { color: "red" } }, [
                            _vm._v(
                              _vm._s(_vm.$t("CONFIGURED.FIELD_EXISTS")) + " "
                            )
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "modal-footer" }, slot: "modal-footer" },
            [
              _c(
                "b-btn",
                {
                  attrs: {
                    id: "addNewField",
                    size: "sm",
                    variant: "secondary",
                    disabled: _vm.errorFieldDup || _vm.newFieldAliasName === ""
                  },
                  on: {
                    click: function($event) {
                      _vm.editFieldAlias()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("COMMON.SAVE")) + " ")]
              ),
              _vm._v(" "),
              _c(
                "b-btn",
                {
                  attrs: { size: "sm", variant: "light" },
                  on: {
                    click: function($event) {
                      _vm.$refs.editFieldAliasModal.hide()
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("COMMON.CLOSE")) + " ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "addFieldModal",
          attrs: {
            centered: "",
            "hide-header-close": "",
            title: _vm.$t("CONFIGURED.ADD_GROUP")
          }
        },
        [
          _c(
            "div",
            [
              _c(
                "b-form-group",
                [
                  _c(
                    "b-row",
                    [
                      _c("b-col", { attrs: { sm: "4" } }, [
                        _c("label", [
                          _vm._v(_vm._s(_vm.$t("CONFIGURED.FIELD")))
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "required" }, [_vm._v("*")])
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { sm: "8" } },
                        [
                          _c("b-form-input", {
                            staticClass: "rolename",
                            class: {
                              "is-invalid": _vm.$v.newFieldName.$error,
                              "is-valid": !_vm.$v.newFieldName.$invalid
                            },
                            attrs: {
                              id: "roleName",
                              type: "text",
                              placeholder: _vm.$t("CONFIGURED.FIELD")
                            },
                            on: {
                              input: function($event) {
                                _vm.$v.newFieldName.$touch()
                              }
                            },
                            model: {
                              value: _vm.newFieldName,
                              callback: function($$v) {
                                _vm.newFieldName = $$v
                              },
                              expression: "newFieldName"
                            }
                          }),
                          _vm._v(" "),
                          !_vm.$v.newFieldName.isUnique
                            ? _c("b-form-invalid-feedback", [
                                _vm._v(
                                  "Either Group is already registered or not allowed."
                                )
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-group",
                [
                  _c(
                    "b-row",
                    [
                      _c("b-col", { attrs: { sm: "4" } }, [
                        _c("label", [
                          _vm._v(_vm._s(_vm.$t("CONFIGURED.FIELD_TYPE")))
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "required" }, [_vm._v("*")])
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c("b-form-select", {
                            attrs: { options: _vm.fieldTypes },
                            model: {
                              value: _vm.selectedFieldType,
                              callback: function($$v) {
                                _vm.selectedFieldType = $$v
                              },
                              expression: "selectedFieldType"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              this.selectedFieldType === "name"
                ? _c(
                    "b-form-group",
                    [
                      _c(
                        "b-row",
                        [
                          _c("b-col", { attrs: { sm: "4" } }, [
                            _c("label", [_vm._v("Field Children")]),
                            _vm._v(" "),
                            _c("span", { staticClass: "required" }, [
                              _vm._v("*")
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("multiselect", {
                                staticClass: "custom-multiselect",
                                staticStyle: { "z-index": "99" },
                                attrs: {
                                  options: _vm.fieldChildren,
                                  "track-by": "value",
                                  label: "text",
                                  multiple: true
                                },
                                model: {
                                  value: _vm.selectedFieldChildren,
                                  callback: function($$v) {
                                    _vm.selectedFieldChildren = $$v
                                  },
                                  expression: "selectedFieldChildren"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-form-radio-group",
                [
                  _c(
                    "b-row",
                    [
                      _c("b-col", { attrs: { sm: "4" } }, [
                        _c("label", [_vm._v("Extract")])
                      ]),
                      _vm._v(" "),
                      _c("b-col", { attrs: { sm: "4" } }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "custom-control custom-radio custom-control-inline"
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.extract,
                                  expression: "extract"
                                }
                              ],
                              staticClass: "custom-control-input",
                              attrs: { type: "radio", id: "extractYes" },
                              domProps: {
                                value: true,
                                checked: _vm._q(_vm.extract, true)
                              },
                              on: {
                                change: function($event) {
                                  _vm.extract = true
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "custom-control-label",
                                attrs: { for: "extractYes" }
                              },
                              [_vm._v(_vm._s(_vm.$t("COMMON.YES")))]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "custom-control custom-radio custom-control-inline"
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.extract,
                                  expression: "extract"
                                }
                              ],
                              staticClass: "custom-control-input",
                              attrs: { type: "radio", id: "extractNo" },
                              domProps: {
                                value: false,
                                checked: _vm._q(_vm.extract, false)
                              },
                              on: {
                                change: function($event) {
                                  _vm.extract = false
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "custom-control-label",
                                attrs: { for: "extractNo" }
                              },
                              [_vm._v(_vm._s(_vm.$t("COMMON.NO")))]
                            )
                          ]
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              this.selectedFilterProcessType === "insurance_cards"
                ? _c(
                    "div",
                    [
                      _c(
                        "b-form-group",
                        [
                          _c(
                            "b-row",
                            [
                              _c("b-col", { attrs: { sm: "4" } }, [
                                _c("label", [
                                  _vm._v(
                                    _vm._s(_vm.$t("CONFIGURED.FIELD_ALIAS"))
                                  )
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "required" }, [
                                  _vm._v("*")
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { sm: "8" } },
                                [
                                  _c("b-form-input", {
                                    staticClass: "rolename",
                                    attrs: {
                                      id: "roleName",
                                      type: "text",
                                      placeholder: _vm.$t(
                                        "CONFIGURED.FIELD_ALIAS"
                                      )
                                    },
                                    model: {
                                      value: _vm.newFieldAlias,
                                      callback: function($$v) {
                                        _vm.newFieldAlias = $$v
                                      },
                                      expression: "newFieldAlias"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-radio-group",
                        [
                          _c(
                            "b-row",
                            [
                              _c("b-col", { attrs: { sm: "4" } }, [
                                _c("label", [
                                  _vm._v(_vm._s(_vm.$t("CONFIGURED.REQ")))
                                ])
                              ]),
                              _vm._v(" "),
                              _c("b-col", { attrs: { sm: "4" } }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "custom-control custom-radio custom-control-inline"
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.isRequired,
                                          expression: "isRequired"
                                        }
                                      ],
                                      staticClass: "custom-control-input",
                                      attrs: {
                                        type: "radio",
                                        id: "requiredNewYes"
                                      },
                                      domProps: {
                                        value: true,
                                        checked: _vm._q(_vm.isRequired, true)
                                      },
                                      on: {
                                        change: function($event) {
                                          _vm.isRequired = true
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "custom-control-label",
                                        attrs: { for: "requiredNewYes" }
                                      },
                                      [_vm._v(_vm._s(_vm.$t("COMMON.YES")))]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "custom-control custom-radio custom-control-inline"
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.isRequired,
                                          expression: "isRequired"
                                        }
                                      ],
                                      staticClass: "custom-control-input",
                                      attrs: {
                                        type: "radio",
                                        id: "requiredNewNo"
                                      },
                                      domProps: {
                                        value: false,
                                        checked: _vm._q(_vm.isRequired, false)
                                      },
                                      on: {
                                        change: function($event) {
                                          _vm.isRequired = false
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "custom-control-label",
                                        attrs: { for: "requiredNewNo" }
                                      },
                                      [_vm._v(_vm._s(_vm.$t("COMMON.NO")))]
                                    )
                                  ]
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        [
                          _c(
                            "b-row",
                            [
                              _c("b-col", { attrs: { sm: "4" } }, [
                                _c("label", [
                                  _vm._v(_vm._s(_vm.$t("CONFIGURED.QUERY")))
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "required" }, [
                                  _vm._v("*")
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c("b-form-textarea", {
                                    attrs: { placeholder: "Query", rows: "4" },
                                    model: {
                                      value: _vm.editQuery,
                                      callback: function($$v) {
                                        _vm.editQuery = $$v
                                      },
                                      expression: "editQuery"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "modal-footer" }, slot: "modal-footer" },
            [
              _c(
                "b-btn",
                {
                  attrs: {
                    size: "sm",
                    variant: "secondary",
                    disabled:
                      !_vm.$v.newFieldName.isUnique ||
                      _vm.selectedFieldType === null ||
                      _vm.newFieldName === "" ||
                      _vm.editQuery === "" ||
                      _vm.newFieldAlias === "" ||
                      (_vm.selectedFieldType === "name"
                        ? _vm.selectedFieldChildren === []
                        : false)
                  },
                  on: {
                    click: function($event) {
                      _vm.addField()
                    }
                  }
                },
                [_vm._v(" Save ")]
              ),
              _vm._v(" "),
              _c(
                "b-btn",
                {
                  attrs: { size: "sm", variant: "light" },
                  on: {
                    click: function($event) {
                      _vm.$refs.addFieldModal.hide()
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("COMMON.CLOSE")) + " ")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "editGroupModal",
          attrs: {
            centered: "",
            "hide-header-close": "",
            title: _vm.$t("CONFIGURED.EDIT_GROUP")
          }
        },
        [
          _c(
            "div",
            [
              _c(
                "b-form-group",
                [
                  _c(
                    "b-row",
                    [
                      _c("b-col", { attrs: { sm: "4" } }, [
                        _c("label", [
                          _vm._v(_vm._s(_vm.$t("CONFIGURED.FIELD")))
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "required" }, [_vm._v("*")])
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { sm: "8" } },
                        [
                          _c("b-form-input", {
                            staticClass: "rolename",
                            class: {
                              "is-invalid": _vm.$v.newFieldName.$error,
                              "is-valid": !_vm.$v.newFieldName.$invalid
                            },
                            attrs: {
                              id: "roleName",
                              type: "text",
                              placeholder: _vm.$t("CONFIGURED.FIELD")
                            },
                            on: {
                              input: function($event) {
                                _vm.$v.newFieldName.$touch()
                              }
                            },
                            model: {
                              value: _vm.newFieldName,
                              callback: function($$v) {
                                _vm.newFieldName = $$v
                              },
                              expression: "newFieldName"
                            }
                          }),
                          _vm._v(" "),
                          !_vm.$v.newFieldName.isUnique
                            ? _c("b-form-invalid-feedback", [
                                _vm._v(
                                  "Either Group is already registered or not allowed."
                                )
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-group",
                [
                  _c(
                    "b-row",
                    [
                      _c("b-col", { attrs: { sm: "4" } }, [
                        _c("label", [
                          _vm._v(_vm._s(_vm.$t("CONFIGURED.FIELD_TYPE")))
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "required" }, [_vm._v("*")])
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c("b-form-select", {
                            attrs: { options: _vm.fieldTypes },
                            model: {
                              value: _vm.selectedFieldType,
                              callback: function($$v) {
                                _vm.selectedFieldType = $$v
                              },
                              expression: "selectedFieldType"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              this.selectedFieldType === "name"
                ? _c(
                    "b-form-group",
                    [
                      _c(
                        "b-row",
                        [
                          _c("b-col", { attrs: { sm: "4" } }, [
                            _c("label", [_vm._v("Field Children")]),
                            _vm._v(" "),
                            _c("span", { staticClass: "required" }, [
                              _vm._v("*")
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("multiselect", {
                                staticClass: "custom-multiselect",
                                staticStyle: { "z-index": "99" },
                                attrs: {
                                  options: _vm.fieldChildren,
                                  "track-by": "text",
                                  label: "text",
                                  multiple: true
                                },
                                model: {
                                  value: _vm.selectedFieldChildren,
                                  callback: function($$v) {
                                    _vm.selectedFieldChildren = $$v
                                  },
                                  expression: "selectedFieldChildren"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-form-radio-group",
                [
                  _c(
                    "b-row",
                    [
                      _c("b-col", { attrs: { sm: "4" } }, [
                        _c("label", [_vm._v("Extract")])
                      ]),
                      _vm._v(" "),
                      _c("b-col", { attrs: { sm: "4" } }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "custom-control custom-radio custom-control-inline"
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.extract,
                                  expression: "extract"
                                }
                              ],
                              staticClass: "custom-control-input",
                              attrs: { type: "radio", id: "extractYes" },
                              domProps: {
                                value: true,
                                checked: _vm._q(_vm.extract, true)
                              },
                              on: {
                                change: function($event) {
                                  _vm.extract = true
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "custom-control-label",
                                attrs: { for: "extractYes" }
                              },
                              [_vm._v(_vm._s(_vm.$t("COMMON.YES")))]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "custom-control custom-radio custom-control-inline"
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.extract,
                                  expression: "extract"
                                }
                              ],
                              staticClass: "custom-control-input",
                              attrs: { type: "radio", id: "extractNo" },
                              domProps: {
                                value: false,
                                checked: _vm._q(_vm.extract, false)
                              },
                              on: {
                                change: function($event) {
                                  _vm.extract = false
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "custom-control-label",
                                attrs: { for: "extractNo" }
                              },
                              [_vm._v(_vm._s(_vm.$t("COMMON.NO")))]
                            )
                          ]
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              this.selectedFilterProcessType === "insurance_cards"
                ? _c(
                    "div",
                    [
                      _c(
                        "b-form-group",
                        [
                          _c(
                            "b-row",
                            [
                              _c("b-col", { attrs: { sm: "4" } }, [
                                _c("label", [
                                  _vm._v(
                                    _vm._s(_vm.$t("CONFIGURED.FIELD_ALIAS"))
                                  )
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "required" }, [
                                  _vm._v("*")
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { sm: "8" } },
                                [
                                  _c("b-form-input", {
                                    staticClass: "rolename",
                                    attrs: {
                                      id: "roleName",
                                      type: "text",
                                      placeholder: _vm.$t(
                                        "CONFIGURED.FIELD_ALIAS"
                                      )
                                    },
                                    model: {
                                      value: _vm.newFieldAlias,
                                      callback: function($$v) {
                                        _vm.newFieldAlias = $$v
                                      },
                                      expression: "newFieldAlias"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-radio-group",
                        [
                          _c(
                            "b-row",
                            [
                              _c("b-col", { attrs: { sm: "4" } }, [
                                _c("label", [
                                  _vm._v(_vm._s(_vm.$t("CONFIGURED.REQ")))
                                ])
                              ]),
                              _vm._v(" "),
                              _c("b-col", { attrs: { sm: "4" } }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "custom-control custom-radio custom-control-inline"
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.isRequired,
                                          expression: "isRequired"
                                        }
                                      ],
                                      staticClass: "custom-control-input",
                                      attrs: {
                                        type: "radio",
                                        id: "requiredNewYes"
                                      },
                                      domProps: {
                                        value: true,
                                        checked: _vm._q(_vm.isRequired, true)
                                      },
                                      on: {
                                        change: function($event) {
                                          _vm.isRequired = true
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "custom-control-label",
                                        attrs: { for: "requiredNewYes" }
                                      },
                                      [_vm._v(_vm._s(_vm.$t("COMMON.YES")))]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "custom-control custom-radio custom-control-inline"
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.isRequired,
                                          expression: "isRequired"
                                        }
                                      ],
                                      staticClass: "custom-control-input",
                                      attrs: {
                                        type: "radio",
                                        id: "requiredNewNo"
                                      },
                                      domProps: {
                                        value: false,
                                        checked: _vm._q(_vm.isRequired, false)
                                      },
                                      on: {
                                        change: function($event) {
                                          _vm.isRequired = false
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "custom-control-label",
                                        attrs: { for: "requiredNewNo" }
                                      },
                                      [_vm._v(_vm._s(_vm.$t("COMMON.NO")))]
                                    )
                                  ]
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        [
                          _c(
                            "b-row",
                            [
                              _c("b-col", { attrs: { sm: "4" } }, [
                                _c("label", [
                                  _vm._v(_vm._s(_vm.$t("CONFIGURED.QUERY")))
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "required" }, [
                                  _vm._v("*")
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c("b-form-textarea", {
                                    attrs: { placeholder: "Query", rows: "4" },
                                    model: {
                                      value: _vm.editQuery,
                                      callback: function($$v) {
                                        _vm.editQuery = $$v
                                      },
                                      expression: "editQuery"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "modal-footer" }, slot: "modal-footer" },
            [
              _c(
                "b-btn",
                {
                  attrs: {
                    size: "sm",
                    variant: "secondary",
                    disabled:
                      !_vm.$v.newFieldName.isUnique ||
                      _vm.selectedFieldType === null ||
                      _vm.newFieldName === "" ||
                      _vm.editQuery === "" ||
                      _vm.newFieldAlias === ""
                  },
                  on: {
                    click: function($event) {
                      _vm.editFieldName()
                    }
                  }
                },
                [_vm._v(" Save ")]
              ),
              _vm._v(" "),
              _c(
                "b-btn",
                {
                  attrs: { size: "sm", variant: "light" },
                  on: {
                    click: function($event) {
                      _vm.$refs.editGroupModal.hide()
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("COMMON.CLOSE")) + " ")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6352660a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6352660a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/manageFields.vue
// module id = 1355
// module chunks = 2